(function () {
  const instances = new WeakMap();
  const roots = new Set();
  let rafId = 0;
  let stableViewportHeight = document.documentElement.clientHeight || window.innerHeight || 1;
  let viewportWidth = window.innerWidth;

  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }

  function readNumber(element, property, fallback) {
    const value = window.getComputedStyle(element).getPropertyValue(property);
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function updateInstance(instance) {
    if (!instance.isActive) return;

    const rect = instance.root.getBoundingClientRect();
    const viewport = stableViewportHeight;
    const isNearViewport = rect.bottom >= -viewport * 0.25 && rect.top <= viewport * 1.25;
    if (!isNearViewport) return;

    const progress = clamp((viewport - rect.top) / (viewport + rect.height), 0, 1);
    const distanceBase = Math.max(viewport, rect.height);

    instance.stars.forEach(function (star) {
      const y = distanceBase * star.travel * progress;
      const rotate = star.direction * -8 + star.direction * star.rotation * progress;

      star.element.style.transform = "translate3d(-50%, " + y.toFixed(2) + "px, 0) rotate(" + rotate.toFixed(2) + "deg)";
    });
  }

  function variantThemeFromTitle(title) {
    const normalized = String(title || "").toLowerCase();
    if (normalized.indexOf("blossom") !== -1 || normalized.indexOf("pink") !== -1) return "blossom";
    return "cobalt";
  }

  function applyVariantTheme(root, title) {
    const nextTheme = variantThemeFromTitle(title);
    if (root.dataset.starTheme === nextTheme) return;

    root.dataset.starTheme = nextTheme;
    requestUpdate();
  }

  function syncVariantTheme(root) {
    const productRoot = root.closest("[data-product-root]");
    const selected = productRoot
      ? productRoot.querySelector("[data-variant-option]:checked")
      : null;
    if (selected) applyVariantTheme(root, selected.dataset.variantTitle);
  }

  function playGalleryVideos(root) {
    root.querySelectorAll(".stellr-product-main__gallery-slide video").forEach(function (video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.autoplay = true;
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") playPromise.catch(function () { });
    });
  }

  function runUpdate() {
    roots.forEach(function (root) {
      const instance = instances.get(root);
      if (instance) updateInstance(instance);
    });
  }

  function requestUpdate() {
    if (rafId) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = 0;
      runUpdate();
    });
  }

  function refreshViewportMetrics() {
    stableViewportHeight = document.documentElement.clientHeight || window.innerHeight || 1;
    viewportWidth = window.innerWidth;
    requestUpdate();
  }

  function initProductStory(root) {
    if (!root || instances.has(root)) return;

    const starElements = Array.prototype.slice.call(root.querySelectorAll("[data-product-story-star]"));
    if (!starElements.length) return;

    const stars = starElements.map(function (star, index) {
      return {
        element: star,
        travel: readNumber(star, "--travel", 0.75),
        rotation: readNumber(star, "--rotate", 48),
        direction: index % 2 === 0 ? 1 : -1,
      };
    });

    const instance = {
      root: root,
      stars: stars,
      isActive: true,
      observer: null,
    };

    if ("IntersectionObserver" in window) {
      instance.observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          instance.isActive = entry.isIntersecting;
          if (instance.isActive) requestUpdate();
        });
      }, { rootMargin: "25% 0px", threshold: 0 });
      instance.observer.observe(root);
    }

    instances.set(root, instance);
    roots.add(root);
    syncVariantTheme(root);
    playGalleryVideos(root);
    updateInstance(instance);
  }

  function destroyProductStory(root) {
    const instance = instances.get(root);
    if (!instance) return;

    instance.stars.forEach(function (star) {
      star.element.style.transform = "";
    });
    instance.observer?.disconnect();
    roots.delete(root);
    instances.delete(root);
  }

  function initAll() {
    document.querySelectorAll("[data-stellr-product-story]").forEach(initProductStory);
    requestUpdate();
  }

  function handleResize() {
    if (window.innerWidth === viewportWidth) return;
    refreshViewportMetrics();
  }

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll, { passive: true });
  window.addEventListener("scroll", requestUpdate, { passive: true });
  window.addEventListener("resize", handleResize, { passive: true });
  window.addEventListener("orientationchange", function () {
    window.setTimeout(refreshViewportMetrics, 180);
  }, { passive: true });

  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-stellr-product-story]").forEach(initProductStory);
    requestUpdate();
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-stellr-product-story]").forEach(destroyProductStory);
  });

  document.addEventListener("change", function (event) {
    if (!event.target.matches("[data-variant-option]")) return;

    const productRoot = event.target.closest("[data-product-root]");
    const story = productRoot ? productRoot.querySelector("[data-stellr-product-story]") : null;
    if (!story) return;

    applyVariantTheme(story, event.target.dataset.variantTitle);
  });

  window.StellrProductStory = { init: initAll, refresh: requestUpdate };
})();
